'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildWidgetData = undefined;

var _pipe = require('transmute/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _immutable = require('immutable');

var _WidgetData = require('conversations-schema/records/WidgetData');

var _WidgetData2 = _interopRequireDefault(_WidgetData);

var _Responder = require('conversations-schema/responders/records/Responder');

var _Responder2 = _interopRequireDefault(_Responder);

var _TypicalResponseTime = require('conversations-schema/typical-response-time/records/TypicalResponseTime');

var _TypicalResponseTime2 = _interopRequireDefault(_TypicalResponseTime);

var _color = require('conversations-visitor-experience-components/visitor-widget/util/color');

var _propertyValues = require('conversations-schema/lib/propertyValues');

var _WidgetAvailabilityOptions = require('conversations-schema/availability/records/WidgetAvailabilityOptions');

var _WidgetAvailabilityOptions2 = _interopRequireDefault(_WidgetAvailabilityOptions);

var _buildWelcomeMessage = require('./buildWelcomeMessage');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var buildWidgetData = exports.buildWidgetData = function buildWidgetData() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var botResponder = data.botResponder ? (0, _Responder2.default)(data.botResponder) : null;
  var responders = data.sendFrom || [];
  var sendFrom = data.sendFrom || [];

  var responder = botResponder || sendFrom[0];

  var returnValue = void 0;

  try {
    returnValue = (0, _pipe2.default)((0, _propertyValues.enforceValues)({
      availabilityOptions: new _WidgetAvailabilityOptions2.default(data.availabilityOptions),
      botResponder: botResponder,
      coloring: (0, _color.buildColorRecord)(data.accentColor),
      gates: (0, _immutable.Map)(data.gates),
      inOfficeHours: data.inOfficeHours,
      message: (0, _buildWelcomeMessage.buildWelcomeMessage)(data.message),
      messagesPageUri: data.messagesPageUri,
      nextStartTime: data.nextOfficeHoursStartTime,
      responder: (0, _Responder2.default)(responder),
      responders: (0, _immutable.List)(responders).map(_Responder2.default),
      sendFrom: (0, _immutable.List)(sendFrom).map(_Responder2.default),
      typicalResponseTime: (0, _TypicalResponseTime2.default)(data.typicalResponseTime),
      widgetLocation: data.widgetLocation
    }), _WidgetData2.default)(data);
  } catch (e) {
    window.Raven.captureMessage('BUILD_WIDGET_DATA_ERROR', {
      extra: {
        data: data
      }
    });
  }

  return returnValue;
};